import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import AppContext from 'context/Context';

const CostImpressionDropdown = ({
  btnRevealClass,
  icon = 'ellipsis-h',
  row,
  onEdit,
  onDelete
}) => {
  const {
    config: { isRTL }
  } = useContext(AppContext);

  const [show, setShow] = useState(false);

  const handleEdit = () => {
    onEdit(row.values);
    setShow(false); // Close the dropdown
  };

  const handleDelete = () => {
    onDelete(row.values);
    setShow(false); // Close the dropdown
  };

  return (
    <Dropdown
      className="font-sans-serif btn-reveal-trigger"
      align={isRTL ? 'start' : 'end'}
      drop="up"
      show={show}
      onToggle={() => setShow(prev => !prev)}
      autoClose="outside"
    >
      <Dropdown.Toggle
        variant="link"
        size="sm"
        data-boundary="viewport"
        className={classNames('text-600', {
          [btnRevealClass]: btnRevealClass,
          'btn-reveal': !btnRevealClass
        })}
      >
        <FontAwesomeIcon icon={icon} className="fs--2" />
      </Dropdown.Toggle>

      <Dropdown.Menu className="border py-0">
        <div className="py-2">
          <Dropdown.Item onClick={handleEdit}>
            <span>Edit</span>
          </Dropdown.Item>
          <Dropdown.Item onClick={handleDelete} className="text-danger">
            <span>Delete</span>
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

CostImpressionDropdown.propTypes = {
  btnRevealClass: PropTypes.string,
  icon: PropTypes.string,
  row: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func
};

export default CostImpressionDropdown;
